import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import UniversalMovieFooterEditor from 'components/editor/movies/movieFooter/movieFooterUniversal';
import FocusMovieFooterEditor from 'components/editor/movies/movieFooter/movieFooterFocus';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieFooterEditor {...props} />;
	return <UniversalMovieFooterEditor {...props} />;
};